import { useContext } from 'react';
import { ExpressCheckoutButtonsContext } from './ExpressCheckoutButtonsContext';
export const useExpressCheckoutButtonsProps = () => {
  return useContext(ExpressCheckoutButtonsContext);
};
//# sourceMappingURL=useExpressCheckoutButtonsProps.js.map